/** Pick first value when OpenFIGI-style fields arrive as arrays. */
const firstValue = (value) => {
  if (Array.isArray(value)) return value[0] ?? "";
  return value ?? "";
};

const mapSecurityFields = (fields, fallbackId = "") => {
  const bloombergTicker = firstValue(fields?.bloomberg_ticker);
  const factsetTicker = firstValue(fields?.factset_ticker);
  const securityKey = fields?.security_key || firstValue(fields?.figi) || fallbackId;
  const ticker = bloombergTicker || fallbackId;

  return {
    id: securityKey || ticker || fallbackId,
    security_key: securityKey,
    tickerSymbol: ticker,
    ticker: { symbol: ticker },
    name: firstValue(fields?.name),
    figi: firstValue(fields?.figi),
    sedol: firstValue(fields?.sedol),
    cusip: firstValue(fields?.cusip),
    isin: firstValue(fields?.isin),
    fs_perm_id: firstValue(fields?.fs_perm_id),
    bloomberg_ticker: bloombergTicker,
    bloomberg: bloombergTicker,
    factset_ticker: factsetTicker,
    factset: factsetTicker,
    arcana_id: firstValue(fields?.arcana_id),
  };
};

/**
 * Normalize resolve_securities response into Security Master table rows.
 * Supports keyed object results or an array of field objects.
 */
export function normalizeResolveSecuritiesPayload(data) {
  if (!data) return [];

  if (Array.isArray(data)) {
    return data.map((item, index) => mapSecurityFields(item, String(index)));
  }
  if (Array.isArray(data.securities)) {
    return data.securities.map((item, index) =>
      mapSecurityFields(item, String(index))
    );
  }
  if (Array.isArray(data.securityMasterItems)) {
    return data.securityMasterItems.map((item, index) =>
      mapSecurityFields(item, String(index))
    );
  }
  if (Array.isArray(data.results)) {
    return data.results.map((item, index) =>
      mapSecurityFields(item, String(index))
    );
  }

  const results = data.results;
  if (!results || typeof results !== "object") return [];

  return Object.entries(results).map(([identifier, fields]) =>
    mapSecurityFields(fields, identifier)
  );
}
